/** @jsx jsx */

import { MouseEvent } from 'react';

import { jsx } from '@emotion/core';
import { Alert, AlertDescription, LegacyButton } from '@zapier/design-system';

type Props = {
  onClick: (event: MouseEvent) => void;
};

/**
 * Renders the Error Block when documentation fails to fetch.
 * Allows the user to retry
 *
 * @param {object} props
 */
const ErrorBlock = (props: Props) => {
  return (
    <Alert status="warning" title="Oops!">
      <AlertDescription>
        We couldn‘t load this content for some reason.
      </AlertDescription>
      <LegacyButton
        color="primary"
        iconBefore="arrowRefresh"
        onClick={props.onClick}
      >
        Try again
      </LegacyButton>
    </Alert>
  );
};

export default ErrorBlock;
